import React = require('react');
import { Messages } from '~src/codegen/Localize';
import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import { L10n } from '~src/ts/L10n/L10n';

export function LicenseExpirationWarning() {
  const licenseExpirationDateIfWithinWarningPeriod = ServerSettingsUnauthenticated.licenseExpirationDateIfWithinWarningPeriod();

  if (!licenseExpirationDateIfWithinWarningPeriod) {
    return null;
  }

  return <div className={'tb-login-msg-container'}>
    <div className={'tb-login-msg tb-login-error'} tb-test-id="license-warning" role="alert">
      <div>{Messages.licenseExpirationDateWarningMessage({
        LICENSE_EXPIRATION_DATE: L10n.localizedDateTime(licenseExpirationDateIfWithinWarningPeriod)
      })}</div>
    </div>
  </div>;
}
